import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from './../../../_services/common.service';
// import Swal from 'sweetalert2';
import { EncrDecrService } from './../../../_services/encr-decr.service';
import { HttpRequestService } from './../../../_services/http-request.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-successorder',
  templateUrl: './successorder.component.html',
  styleUrls: ['./successorder.component.scss']
})
export class SuccessorderComponent implements OnInit {
	public orderDetails:any;
	public successOrderId:any;
	constructor(public translate: TranslateService, private cService: CommonService,
		private encDecService: EncrDecrService, private router: Router,
		private httpService: HttpRequestService,) {
		this.cService.activelang.subscribe((lang) => {

			// this language will be used as a fallback when a translation isn't found in the current language
			translate.setDefaultLang(lang);

			// the lang to use, if the lang isn't available, it will use the current loader to get them
			translate.use(lang);
		});
	}

  ngOnInit() {
	// console.log(JSON.parse(this.encDecService.get( localStorage.getItem('_payment_info'))));
	//this.orderDetails = JSON.parse(this.encDecService.get( localStorage.getItem('_payment_info')));
    //sessionStorage.removeItem('_corder');
    //localStorage.removeItem('_current_shipping');
	this.cService.setCartItmsCount(0);
    console.log(sessionStorage.getItem('order_id')); 


    let orderSuccessDetails = sessionStorage.getItem('order_id');

    console.log(orderSuccessDetails);

     this.httpService.setModule('action').post('pay_success', {
               "order_id":(orderSuccessDetails)?orderSuccessDetails:null,
              }).subscribe((response) => {
             console.log(response);

             //sessionStorage.removeItem('order_id');
             sessionStorage.removeItem('_corder');
    		 localStorage.removeItem('_current_shipping');

    		 this.successOrderId = sessionStorage.getItem('order_id');
               
             })

  }
	pageRedirect() {
		
	if(localStorage.getItem('_payment_for') && localStorage.getItem('_payment_for')=="P"){
		this.router.navigate(['profile','orders']);
	} else {
		this.router.navigate(['profile','booking-history']);
	}
  }
}
